import type { Plugins } from 'core/plugins/config/types';

/**
 * Check if required Plugins exist for a Plugin.
 */
export function requiredPluginsExist(
  requiredPlugins: string[] | undefined,
  pluginsAvailable: Map<string, Plugins.Model> = new Map(),
): boolean {
  return !requiredPlugins || requiredPlugins.every((req) => pluginsAvailable.has(req));
}
